
import DownloadPluginModal from '~/components/default/DownloadPluginModal.vue'

export default {
  name: 'AppFooter',
  components: { DownloadPluginModal },
  data () {
    return {
      currentYear: (new Date()).getFullYear(),
      openDownload: false
    }
  }
}
